module.exports = __webpack_public_path__ + "img/ic_bolt_white_24dp@2x.0ea4deff.png";